export const asideStyles =
  "fixed mt-16 flex flex-col lg:mt-0 top-0 px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200 ";

export const logoContainerStyles = "py-8 flex w-full";

export const navStyles = "mb-6";

export const menuListStyles = "flex flex-col gap-3"; // Increased gap for better spacing

export const menuItemStyles = "flex items-center p-2 rounded-lg group hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-200 w-full";

export const menuItemIconStyles = "w-6 h-6 text-gray-600 dark:text-gray-400 flex-shrink-0 transition-colors duration-200"; // Increased size and centered

export const menuItemTextStyles = "ml-3 text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 transition-colors duration-200";

export const chevronStyles = "ml-auto w-5 h-5 text-gray-600 dark:text-gray-400 transition-transform duration-200";

export const submenuContainerStyles = "overflow-hidden transition-all duration-300";

export const submenuListStyles = "mt-2 space-y-1 ml-9";

export const submenuItemStyles = "menu-dropdown-item";